var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgLengthIcon = function SvgLengthIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 3.019V2h2V1a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v1h2v1.019a6.5 6.5 0 1 0 1 0m3.036 10.017c-.944.944-2.2 1.464-3.536 1.464s-2.591-.52-3.536-1.464S2.5 10.836 2.5 9.5s.52-2.591 1.464-3.536a4.97 4.97 0 0 1 3.377-1.462l-.339 4.907c-.029.411.195.591.497.591s.527-.18.497-.591l-.339-4.907c1.276.04 2.47.555 3.377 1.462.944.944 1.464 2.2 1.464 3.536s-.52 2.591-1.464 3.536z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLengthIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;